module.exports = __webpack_public_path__ + "img/net.7d77ef81.png";